import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { FormControlLabel, Switch } from "@mui/material";
import useModalStore from "zustand/zustandstore"; // Ensure this is correctly imported
import api from "api/api";
import axios from "axios";

const AddMeetDetails = ({ isOpen, close,toastMessage,showtoast,severity}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [patientid, setPatientId] = useState('');
  const [patientName, setPatientName] = useState('');
const [ui,setui]=useState(0)
const [meetingPlatform ,setMeetingPlatform]=useState('googleMeet')

const [isButtonLoading,setIsButtonLoading]=useState()
const [meetlink,setMeetlink]=useState('')
const token = sessionStorage.getItem("auth");
const [id,setId]=useState('')
const [audiolink,setAudioLink]=useState('')
  const handleSubmit = async() => {
    if (!patientName) {
      setErrorMessage('Please enter Conversation');
      return;
    }
    if (!patientid) {
      setErrorMessage('Please enter Note');
      return;
    }
    try {
setIsButtonLoading(true)
        const response=await api.post(`/v1/recording/patientid/1234/notes/create`,{
             "notes": patientid,
  "tags": patientName
        })
        if(response.status===200){
setAudioLink(response?.data?.audiolink)
setId(response?.data?.id)
toastMessage("Record is created. Now, add the meeting link.")
severity("success")
showtoast(true)
setui(1)
        }else{
          toastMessage(response?.message)
          severity("info")
          showtoast(true)
        }
       

    } catch (error) {
      toastMessage("something went wrong")
severity("error")
showtoast(true)
        console.log(error)
    }finally{
            // Clear form fields
  
    setIsButtonLoading(false)
    }


  };
const addmeet=async()=>{
  try {
    setIsButtonLoading(true)
    const user =await  api.get('/auth/me')

    const response = await axios.post(`https://api.prd.brainymed.com/bs-business/v1/start-meet/${meetingPlatform === 'teams' ? 'microsoft' : 'google'}`,{
      "meet_url": meetlink,
"practiceid": `${user?.config?.practiceid}`,
  "departmentid":user?.config?.departmentid,
  "patientid": "1234",
  "notes": patientid,
  "tags": patientName,
   "category":"combine",
   "rowid":id,
  "filename":audiolink,
  "token": token
    })
    setIsButtonLoading(false)
    setPatientId('');
    setPatientName('');
    setMeetlink('')
    setui(0)
  close(false)
  } catch (error) {
    toastMessage("something went wrong")
    severity("error")
    showtoast(true)
    console.log(error)
  }finally{
    setIsButtonLoading(false)
    setPatientId('');
    setPatientName('');
    setMeetlink('')
    setui(0)
  close(false)
  }
}
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-4 sm:p-6 min-h-[50vh] rounded-[15px] shadow-lg w-[90%] sm:w-[70%] max-w-md relative flex flex-col">
      <button
        onClick={() => {
          setPatientName('');
          setPatientId('');
          setMeetlink('')
          setui(0)
        close(false)

        }}
        className="absolute top-2 right-2 text-gray-600 hover:text-black"
      >
        <CloseIcon />
      </button>
      {ui===0?<div className="flex flex-col items-center mt-5 justify-between flex-grow">
        <div className="mb-4 text-center">
        <div className="font-bold text-[#1C2A3A] text-lg sm:text-xl leading-7">Add Details</div></div>

        {/* Patient Name Input */}
    
        
        <>
          <div className=" mb-4 flex flex-col  w-[80%] mx-auto">
<label className="text-start text-md w-full font-semibold mb-2">Name</label>
 <div className="">
       
          <input
            type="text"
            value={patientName}
            onChange={(e) => {
              if (errorMessage) setErrorMessage('');
              setPatientName(e.target.value);
            }}
            placeholder="Enter Conversation Name"
            className="w-full bg-transparent h-[45px] border border-gray-300 p-3  rounded-lg outline-none text-gray-800 text-sm font-normal"
          />
          {/* <img src={usericon} alt="User Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" /> */}
        </div></div>

        <div className=" mb-4 w-[80%] flex flex-col mx-auto">
          <label className="text-start text-md w-full font-semibold mb-2">Notes</label>
          <textarea
            value={patientid}
            onChange={(e) => {
              if (errorMessage) setErrorMessage('');
              setPatientId(e.target.value);
            }}
            placeholder=""
            rows="6"
            className="w-full bg-transparent border border-gray-300 p-3  rounded-lg outline-none text-gray-800 text-sm font-normal resize-none"
          ></textarea>
      
        </div>
        
        </>
 


        {/* Error Message */}
        {errorMessage && (
          <div className="text-red-500 text-xs sm:text-sm mb-4 w-[80%] mx-auto">
            {errorMessage}
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center justify-center mt-4 gap-5 w-full">
        <button
  onClick={() => handleSubmit()}
  disabled={isButtonLoading}
  className={`w-[40%] p-4 h-10 ${
    isButtonLoading? "bg-gray-500 cursor-not-allowed" : "bg-[#1c2a3a]"
  } text-white text-sm font-semibold rounded-[14px] flex items-center justify-center`}
>
  {isButtonLoading ? "Recording..." : "Start Recording"}
</button>

          <button
            onClick={() => {
              setPatientName('');
              setPatientId('');
              setMeetlink('')
              setui(0)
        close(false)
       
            }}
            className="w-[40%] p-4 h-10 bg-[#1c2a3a] text-white text-sm font-semibold rounded-[14px] flex items-center justify-center"
          >
            Cancel
          </button>
        </div>
      </div>:<>
      <div className="mb-4 flex flex-col w-[80%] mx-auto">
  <label className="text-start text-md w-full font-semibold mb-2">
    Select Meeting Platform
  </label>
  <div className="flex items-center gap-4 mb-4">
    <label className="flex items-center">
      <input
        type="radio"
        name="meetingPlatform"
        value="googleMeet"
        checked={meetingPlatform === 'googleMeet'}
        onChange={() => setMeetingPlatform('googleMeet')}
        className="mr-2"
      />
      Google Meet
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        name="meetingPlatform"
        value="teams"
        checked={meetingPlatform === 'teams'}
        onChange={() => setMeetingPlatform('teams')}
        className="mr-2"
      />
      Microsoft Teams
    </label>
  </div>

  <label className="text-start text-md w-full font-semibold mb-2">
    Enter Meeting URL
  </label>
  <div>
    <textarea
      value={meetlink}
      onChange={(e) => {
        if (errorMessage) setErrorMessage('');
        setMeetlink(e.target.value);
      }}
      placeholder={`Paste your ${
        meetingPlatform === 'teams' ? 'Microsoft Teams' : 'Google Meet'
      } URL`}
      rows="10"
      className="w-full bg-transparent border border-gray-300 p-3 rounded-lg outline-none text-gray-800 text-sm font-normal resize-none"
    ></textarea>
  </div>
</div>


        <button
  onClick={() => addmeet()}
  disabled={isButtonLoading||!meetlink}
  className={`w-full p-4 h-10 ${
    isButtonLoading ? "bg-gray-500 cursor-not-allowed" : "bg-[#1c2a3a]"
  } text-white text-sm font-semibold rounded-[14px] flex items-center justify-center`}
>
  {isButtonLoading? "Submitting..." : "Submit"}
</button>

      
      </>}
    </div>
  </div>
  );
};

export default AddMeetDetails;
